<div class="row appFooter animate__bounce">
  <div class="col-12 appFooter__main">
    <div class="container-xl">
      <div class="row f-a">
        <div class="col-xs-12 col-sm-6 col-md-3 smb3">
          <img src="assets/images/kunnect-light-logo.svg" alt="Logo" />
          <span class="sfont12 spr2">
            iKunnect empowers your organization to increase productivity, reduce
            operational costs, and improve customer satisfaction, making it the
            ideal choice for businesses seeking a reliable and efficient call
            center solution. Experience the difference with iKUNNECT and
            transform your customer interactions today.
          </span>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3 smb3">
          <p>SERVICES</p>

          <ul>
            <li>24/7/365 Customer Service</li>
            <li>Third party Integration</li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
          <p>GET IN TOUCH</p>
          <ul>
            <li>
              <a href="mailto:info@ikunnect.com"> info&#64;ikunnect.com </a>
            </li>
            <li>469.946.9242 <br /></li>
            <li>Southlake, TX</li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
          <p>PLANNING TOOLS</p>
          <p
            class="cursor-p"
            routerLink="/contact-us"
            routerLinkActive="active">
            Contact Us
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 appFooter__copy">
    <div class="container-xl">
      <div class="row">
        <div class="col-xs-12 col-sm-8">
          <ul class="nav">
            <li class="nav-item" routerLink="/privacy">Privacy Statement</li>
            <li class="nav-item" routerLink="/terms">Terms & Conditions</li>
            <li class="nav-item">Sitemap</li>
            <li class="nav-item">Security Policy</li>
          </ul>
        </div>
        <div class="col-xs-12 col-sm-4">
          Copyright 2025. Invictus. All Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</div>
